<template>
  <div id="func-50">
  <funcionalidade-header :titulo="tituloHeader" :voltar="!isWidget" />
  <div class="main">
    <SolicitacaoListagem
      :funcionalidade="funcionalidade"
      :rota-detalhe="rotaDetalhe"
      :rota-historico="rotaHistorico"
      :rota-novo="rotaNovo"
    />
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import { mapGetters, mapState } from 'vuex'
import SolicitacaoListagem from '@/components/TemplateSolicitacao/SolicitacaoListagem'
export default {
  data () {
    return {
      solicitacoesList: []
    }
  },
  components: { FuncionalidadeHeader, SolicitacaoListagem },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('SetupApp', ['isWidget']),
    tituloHeader () {
      return this.funcionalidade.parametros.textos.tituloListagemSolicitacao
    },
    rotaNovo () {
      return `/${this.funcionalidade.idFuncionalidade}/novo`
    },
    rotaHistorico () {
      return `/${this.funcionalidade.idFuncionalidade}/historico`
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    }
  }
}
</script>
<style lang="less">
#func-50 {
  .main {
    margin-top: 30px;
    padding: 0 15px 20px;
  }
}
</style>
